import { round, sumBy } from 'lodash';
import { allocationsHelpers } from 'further-ui/domain';

const recalculateAndBalanceAllocations = ({
  allocations,
  commitments,
  targetAmountLcy,
}: {
  allocations: Array<{
    commitmentId: string;
    allocationAmountLcy: number;
    allocationPercentage: number;
    excludeFromAllocation: boolean;
  }>;
  commitments: Array<{
    _id: string;
    isBalancingEntity: boolean;
    totalCommitmentLcy: number;
  }>;
  targetAmountLcy: number;
}) => {
  const totalPercentage = round(sumBy(allocations, 'allocationPercentage'), 5);

  if (totalPercentage !== 100) {
    return;
  }
  const allocationsToBalance = allocations.map((allocation) => ({
    commitmentId: allocation.commitmentId,
    allocationAmountTcy: 0,
    allocationAmountLcy: allocation.allocationAmountLcy,
  }));

  allocationsHelpers.balanceAllocations({
    allocations: allocationsToBalance,
    includedCommitments: commitments,
    targetAmount: targetAmountLcy,
    valueToBalance: 'allocationAmountLcy',
  });

  return allocationsToBalance;
};

export default recalculateAndBalanceAllocations;
